<template>
  <div class="childPannel">
    <!-- <el-input
        v-model="filterValue"
        @input="InputChange"
        style="width: 100%; margin-bottom: 12px"
        placeholder="通过编号、名称进行搜索"
        :prefix-icon="Search"
      /> -->
    <div v-if="list.length" class="childPannel-box">
      <div v-for="m in list" @click="handleClickItem(m)" :key="m.id" class="childPannel-box-item">
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">编号：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.id }}</span>
          </div>
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">名称：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.bridge }}</span>
          </div>
        </div>
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">桥梁类型：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.structuralType }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-empty v-if="!list.length" :image-size="100" description="当前内容为空" />
    <el-pagination
      class="childPannel-pagination"
      v-else
      size="small"
      v-model:current-page="params.pageNum"
      :page-size="params.pageSize"
      background
      :pager-count="5"
      @change="getList"
      layout="prev, pager, next"
      :total="total"
    />
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, watch } from 'vue'
import { toCameraPosition } from './utils'
import { LayerPopupCtrl } from '@/components/LayerPopupCtrl'
import { CesiumObj } from '@/components/GIS/CesiumObj'
import { Cartographic, Math } from 'cesium'
import BridgePopup from '../../Popup/BridgePopup.vue'
import { getBridgeDataInfo } from '@/apiFzn'
import type { IBridgeData } from '@/apiFzn/types'

import { useBridgeStore } from '@/stores/bridge'
const userBridgeStore = useBridgeStore()

import { useMarkStore } from '@/stores/navimark'
const usermarkStore = useMarkStore()

const popupCtrl = LayerPopupCtrl.getInstance();
let cesiumobj: CesiumObj | null = null

const props = defineProps({
  showPannelKey: {
    type: String,
    default: '',
  },
  searchValue: {
    type: String,
    default: '', // 提供默认值
  },
})

const handleClickItem = async (m: IBridgeData) => {
  if (!cesiumobj) cesiumobj = await CesiumObj.getInstance()
  userBridgeStore.openBridgeDetail(m.id),
  usermarkStore.closeDetail()
    popupCtrl.popupMap.forEach((val) => {
      val.destroy()
    })
  toCameraPosition({
    lng: m.longitude,
    lat: m.latitude,
  })
  const cartographic = Cartographic.fromDegrees(m.longitude, m.latitude, 0)
  popupCtrl.popup({
    viewer: cesiumobj.viewer,
    id: m.id,
    lnglat: [cartographic.longitude, cartographic.latitude].map(Math.toDegrees) as [number, number],
    Com: BridgePopup,
    properties: m,
  })
}

const params = reactive({
  bridgeName: '',
  pageNum: 1,
  pageSize: 8,
})
const list = ref<IBridgeData[]>([])
const total = ref(0)

const getList = () => {
  getBridgeDataInfo(params).then((res) => {
    list.value = res.rows
    total.value = res.total
  })
}

defineExpose({
  getList,
})

watch(
  () => props.searchValue,
  (newVal) => {
    params.bridgeName = newVal // 将搜索值赋给查询参数
    params.pageNum = 1 // 重置页码到第一页
  },
  { immediate: true } // 初始化时立即执行一次
)
</script>

<style lang="scss" scoped>
@import url('./childPannel.scss');
</style>
